module.exports = __webpack_public_path__ + "static/media/SyncMonkey_Registration_BG.4ab08b05.png";